<template>
  <div :style="styleContainer">
    <v-fade-transition leave-absolute>
      <div class="smiles_loading" v-show="loading">
        <v-row align="center" justify="center" class="fill-height">
          <v-col>
            <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="image"
              ></v-skeleton-loader>
          </v-col>
        </v-row>
      </div>
    </v-fade-transition>
    <canvas :id="canvasId" :style="styleCanvas"></canvas>
    <!-- <div v-if="!updating && !validSmiles" :style="styleOverlay"></div>
    <div v-if="!updating && !validSmiles" :style="styleIcon">
      <v-icon size="48" color="red lighten-2">mdi-close</v-icon>
    </div> -->
  </div>
</template>

<script>
import SmilesDrawer from 'smiles-drawer';

export default {
  name: 'SmilesDrawer',
  props: {
    id: {
      type: String
    },
    smiles: {
      type: String
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 300
    },
    highlight: {
      type: Array
    }
  },
  data() {
    return {
      loading: true,
      delayHandler: null,
      validSmiles: false,
      updating: false
    };
  },
  watch: {
    smiles() {
      this.delayUpdate();
    },
    highlight() {
      this.delayUpdate();
    }
  },
  computed: {
    canvasId() {
      return this.id || `SMILES_${(this.smiles || '').hashCode()}`;
    },
    styleContainer() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
        margin: 'auto',
        position: 'relative'
      };
    },
    styleCanvas() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`
      };
    },
    styleOverlay() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
        position: 'absolute',
        top: '0px',
        left: '0px'
      };
    },
    styleIcon() {
      return {
        'margin-top': '-24px',
        'margin-left': '-24px',
        position: 'absolute',
        top: '50%',
        left: '50%'
      };
    },
    options() {
      return {
        debug: false,
        width: this.width,
        height: this.height,
        compactDrawing: false
      };
    },
    highlightColor() {
      return '#00695C';
    },
    highlightTextColor() {
      return '#FFF';
    },
    smilesDrawer() {
      return new SmilesDrawer.Drawer(this.options);
    }
  },
  methods: {
    delayUpdate() {
      this.loading = true;
      if (this.smiles != undefined) {
        this.updating = true;
        if (this.delayHandler) clearTimeout(this.delayHandler);
        this.delayHandler = setTimeout(() => this.update(), 500);
      }
    },
    update() {
      SmilesDrawer.parse(
        this.smiles,
        tree => {
          this.smilesDrawer.draw(tree, this.canvasId, 'light', false);
          let cw = this.smilesDrawer.canvasWrapper;
          cw.scale(this.smilesDrawer.graph.vertices);
          this.smilesDrawer.graph.vertices
            .filter(v => (this.highlight || []).includes(v.id))
            .forEach(v => {
              let x = (v.position.x + cw.offsetX) * cw.ratio;
              let y = (v.position.y + cw.offsetY) * cw.ratio;
              try {
                this.drawCustomCircle(cw.ctx, x, y, 8, this.highlightColor);
                this.drawCustomText(
                  cw.ctx,
                  x,
                  y,
                  `${v.id}`,
                  this.highlightTextColor
                );
              } catch (err) {
                console.log(err);
              }
            });
          cw.reset();
          this.updating = false;
          this.validSmiles = true;
          this.$emit('validate', true);
        },
        err => {
          console.log(err);
          this.updating = false;
          this.validSmiles = false;
          this.$emit('validate', false);
        }
      );
      this.loading = false;
    },
    drawCustomCircle(ctx, x, y, radius, color, fill = true) {
      ctx.save();
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2, true);
      ctx.closePath();
      if (fill) {
        ctx.fillStyle = color;
        ctx.fill();
      } else {
        ctx.strokeStyle = color;
        ctx.stroke();
      }
      ctx.restore();
    },
    drawCustomText(ctx, x, y, text, color) {
      ctx.save();
      ctx.font = 'bold 9px Droid Sans, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = color;
      ctx.fillText(text, x, y);
      ctx.restore();
    }
  },
  mounted() {
    this.delayUpdate();
  }
};
</script>
